import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight, faCheckCircle, faCircle, faCircleCheck, faDashboard, faMagnifyingGlass, faMap, faUser, faUserAlt, faUsers } from "@fortawesome/free-solid-svg-icons";
import { faPinterest } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'; // import dropdown icon
import { useState } from "react";
const AdminSideBarMnt = () => {
    function toggleClass() {
        document.getElementById("toggleli").childNodes[1].classList.toggle("collapse")
    }
    function masterClass() {
        document.getElementById("Master").childNodes[1].classList.toggle("collapse")
    }
    function userMenuToggle() {
        document.getElementById("userMenu").childNodes[1].classList.toggle("collapse")
    }
    function surveyMenuToggle() {
        document.getElementById("surveyMenu").childNodes[1].classList.toggle("collapse")
    }
    function UtilizationMenuToggle() {
        document.getElementById("utiMenu").childNodes[1].classList.toggle("collapse")
    }
const userType = sessionStorage.getItem("userTypeCodeModel");
const [assignOpen, setAssignOpen] = useState(false);
    // Function to determine Add User path based on user type
    const getAddUserPath = () => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
        const userCode = sessionStorage.getItem("userCodeModel");
        const userName = sessionStorage.getItem("userNameModel");
        const fmttiCode = sessionStorage.getItem("fmttiCode");
        const fmttiName = sessionStorage.getItem("fmttiName");
        const fmtcCode = sessionStorage.getItem("fmtcCode");
        const fmtcName = sessionStorage.getItem("fmtcName");
     //alert(sessionStorage.getItem("usertypeCodeModel"));   
//alert(sessionStorage.getItem("userNameModel"));
        if (userRoleCode === "1") { // Central login
            return "/MNT/AdmLogin";
        }
        else if (userRoleCode === "2") { // FMTTI login
            return "/MNT/StateUser";
        } else if (userRoleCode === "3") { // District login
            return "/MNT/DistrictUserCreation";
        }
        else if (userRoleCode === "6") { // FMTTI user
            return "/MNT/FmtcUserCreation";
        } 
        else if (userRoleCode === "7") { // FMTC user
            return "/MNT/FmttiSurveyorCreation";
        }
        else if (userRoleCode === "9") { // ICAR login
            return "/MNT/AtariUserCreation";
        } else if (userRoleCode === "8") { // Atari user
            return "/MNT/KvkUserCreation";
        } else if (userRoleCode === "11") { // KVK user
            return "/MNT/CrmSurveyorCreation";
        }
        else if (userRoleCode === "10") { // KVK user
            return "/MNT/KvkUserCreation";
        }
        // Default fallback for surveyors or other roles
        return "/MNT/dashboardMnT";
    };
    

    // Function to determine View User path based on user type
    const getViewUserPath = () => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        

        if (userType === "1") { // Central login
            return "/MNT/usrlistMnt";
        } else if (schemeCode === "1") { // FMTTI scheme
            if (userType === "6") { // FMTTI user
                return "/MNT/fmtcUserView";
            } else if (userType === "7") { // FMTC user
                return "/MNT/FmttiSurveyorView";
            }
        } else if (userType === "9") { // ICAR login
            return "/MNT/AtariUserView";
        } else if (userType === "8") { // Atari user
            return "/MNT/KvkUserView";
        } else if (userType === "5") { // KVK user
            return "/MNT/CrmSurveyorView";
        }
        // Default fallback for other roles
        return "/MNT/dashboardMnT";
    };
 // alert(sessionStorage.getItem("userRoleCodeModel"));
    // Get user role to determine what to show
    const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
    //alert(userRoleCode);
    return (
        <aside id="myDIV" className="sidebar">
            <ul className="sidebar-nav" id="sidebar-nav">
                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/MNT/dashboardMnT">
                        <i><FontAwesomeIcon icon={faDashboard} /></i>
                        <span> Dashboard</span>
                    </NavLink>
                </li>
                            
                {/* Only show View User and Add User for non-surveyor users */}
                {userRoleCode !== "5" && userRoleCode !== "8" && userRoleCode !== "12" && (
                    <>
                        <li className="nav-item">
                            <NavLink className="nav-link collapsed" to={"/MNT/UsrListMnt"}>
                                <i><FontAwesomeIcon icon={faUsers} /></i>
                                <span>View User</span>
                            </NavLink>
                        </li>
                        
                        <li className="nav-item">
                            <NavLink className="nav-link collapsed" to={getAddUserPath()}>
                                <i><FontAwesomeIcon icon={faUser} /></i>
                                <span>Add User</span>
                            </NavLink>
                        </li>
                    </>
                )}
                
                {userRoleCode !== "5" && userRoleCode !== "8" && userRoleCode !== "12" && (
                    <li className="nav-item" id="surveyMenu">
                        <a className="nav-link collapsed" onClick={surveyMenuToggle}>
                            <i><FontAwesomeIcon icon={faUser} /></i>
                            <span>Survey Detail</span>
                            <i className="bi bi-chevron-down ms-auto"></i>
                        </a>
                        <ul className="collapse nav-content">
                            {sessionStorage.getItem("userRoleCodeModel") !== "6" && sessionStorage.getItem("userRoleCodeModel") !== "9"  && sessionStorage.getItem("userRoleCodeModel") !== "10" && sessionStorage.getItem("userRoleCodeModel") !== "11"  && (
                                <li>
                                    <NavLink to={"/MNT/surveyDetail"}>
                                        <i className="bi bi-circle"></i><span>CHC Survey Detail Report</span>
                                    </NavLink>
                                </li>
                            )}
                            {sessionStorage.getItem("userTypeCodeModel") !== "3"  && (
                            <li>
                                <NavLink to={"/MNT/MachinSurveyReport"}>
                                    <i className="bi bi-circle"></i><span>Machine Demonstration Survey Report</span>
                                </NavLink>
                            </li>
                            )}
                          
                           {!["6", "9"].includes(sessionStorage.getItem("userRoleCodeModel")) && (
    <li>
        <NavLink to={"/MNT/IndividualCrmSurvey"}>
            <i className="bi bi-circle"></i>
            <span>Individual Survey Detail</span>
        </NavLink>
    </li>
)}
                        </ul>
                    </li>
                )}
                
                {["1","2","3"].includes(sessionStorage.getItem("userRoleCodeModel")) && sessionStorage.getItem("userTypeCodeModel") !== "3" && (
                <li className="nav-item" id="utiMenu">
                        <a className="nav-link collapsed" onClick={UtilizationMenuToggle}>
                            <i><FontAwesomeIcon icon={faUser} /></i>
                            <span>Utilization of CRM Machine</span>
                            <i className="bi bi-chevron-down ms-auto"></i>
                        </a>
                        <ul className="collapse nav-content">
                           {sessionStorage.getItem("userRoleCodeModel") === "9" ? (
    <>
        <li>
            <NavLink to={"/MNT/CRMCHCUpdatedData"}>
                <i className="bi bi-circle"></i>
                <span>Atari Wise Data</span>
            </NavLink>
        </li>

        <li>
            <NavLink to={"/MNT/KVKWiseData"}>
                <i className="bi bi-circle"></i>
                <span>KVK Wise Data</span>
            </NavLink>
        </li>
    </>
) : (
    <>
        <li>
            <NavLink to={"/MNT/CRMCHCUpdatedData"}>
                <i className="bi bi-circle"></i>
                <span>CRM CHC Updated Data</span>
            </NavLink>
        </li>

        {sessionStorage.getItem("userRoleCodeModel") !== "2" && sessionStorage.getItem("userRoleCodeModel") !== "3" && (
            <li>
                <NavLink to={"/MNT/updatedCRMCHCStateWise"}>
                    <i className="bi bi-circle"></i>
                    <span>Updated CRM CHC State wise</span>
                </NavLink>
            </li>
        )}
    </>
)}

                         
                        </ul>
                    </li>
                )}
                 {/* {sessionStorage.getItem("userRoleCodeModel")!=="9" && (  */}
                 {["1", "2","3","6","7","8"].includes(sessionStorage.getItem("userRoleCodeModel")) && sessionStorage.getItem("userTypeCodeModel") !== "1" && (
                 
                                  <li className="nav-item">
                                    {/* Parent Link */}
                                    <a
                                      href="#!"
                                      className="nav-link"
                                      onClick={(e) => { e.preventDefault(); setAssignOpen(!assignOpen); }}
                                    >
                
                                      <i><FontAwesomeIcon icon={faUsers} /></i>
                                      <span style={{ marginRight: '20px' }}>Assign Target</span>
                
                
                                      {/* Dropdown Icon */}
                                      <i
                                        style={{
                                          transition: 'transform 0.3s',
                                          transform: assignOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faChevronDown} />
                                      </i>
                                    </a>
                
                                    {/* Dropdown Children */}
                                    {assignOpen && (
                                      <ul className="submenu">
                                        {/* Child: Assign Target */}
                                        {/* {["1", "2", "3"].includes(userType) && ( */}
                                          <li>
                                            <NavLink className="nav-link" to="/newadminpanel/assignTarget">
                
                                              Assign Target
                                            </NavLink>
                                          </li>
                                        {/* )} */}
                
                                        {/* Child: Self Assigned Target */}
                                        {["2", "3", "4"].includes(userType) && (
                                          <li>
                                            <NavLink className="nav-link" to="/newadminpanel/selfAssignedTarget">
                                              {userType === '2'
                                                ? 'Center'
                                                : userType === '3'
                                                  ? 'State'
                                                  : userType === '4'
                                                    ? 'District'
                                                    : ''} Assigned Target
                                            </NavLink>
                                          </li>
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                )} 
            </ul>
        </aside>
    )
}

export default AdminSideBarMnt;